<template>
  <main id="contents" class="top-padding top-padding-dark">
    <div class="wrap">
      <div class="search-body">
        <SearchKeywordMultiBand
          v-if="isMultiBand"
          :search-word="searchWord"
          :category="category"
          :key="`${searchWord}_${category}_${mtype}_multi_band`"
        />

        <SearchKeywordList
          v-else
          :search-word="searchWord"
          :category="category"
          :mtype="mtype"
          :key="`${searchWord}_${category}_${mtype}`"
        />
      </div>
    </div>
  </main>
</template>

<script>
import _ from 'lodash'
import SearchKeywordMultiBand from '@/components/search/data/SearchKeywordMultiBand'
import { setNumberCommas, scrollTop, titleTagNameChange } from '@/common/utils/common'
import SearchMixins from '@/mixins/search.mixin'
import SearchKeywordList from '@/components/search/data/SearchKeywordList'
import cookie from '@/common/utils/cookie'

export default {
  components: {
    SearchKeywordMultiBand,
    SearchKeywordList
  },
  mixins: [
    SearchMixins
  ],
  filters: {
    setNumberCommas
  },
  props: {
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  data () {
    return {
      searchWord: '',
      searchTitle: '', // 화면 노출용 (Input창 변경시 화면 노출되는 부분도 같이 변경방지용) bind once 로 처리 가능한지 확인
      category: 'all', // string
      mtype: '',
      isPooqzone: cookie.isWavveOn(),
      pooqzoneType: cookie.getPooqZoneType()
    }
  },
  computed: {
    isMultiBand () {
      return ['all', 'theme'].includes(this.category)
    }
  },
  methods: {
    initialize () {
      scrollTop()
      this.searchWord = _.get(this.$route, ['query', 'searchWord'], '')
      this.category = _.get(this.$route, ['query', 'category'], 'all')
      this.mtype = _.get(this.$route, ['query', 'mtype'], '')
      this.searchTitle = this.searchWord
      this.$events.$emit('setInputShow', false)
      titleTagNameChange(`${this.searchWord} : 웨이브 검색결과`)
    }
  },
  created () {
    scrollTop()
    this.initialize()
  },
  watch: {
    $route () {
      this.initialize()
    }
  }
}
</script>
